const toFloat = (number) => {
  return Number(String(number).replace(/,/g, '.'));
};

export {
  toFloat,
};



// WEBPACK FOOTER //
// ./src/utils/numberUtils.js